import { THUMBNAIL_SETTINGS } from '@plugins/shared/constants/general';

export default {
  languages: ['en', 'de'],
  questionExportPageSize: 100,
  questionPageSize: 10,
  answerPageSize: 10,
  attachmentSizeLimit: 20 * 1024 * 1024, // 20mb
  imageFileSizeLimit: 5 * 1024 * 1024, // 5mb
  imageContentTypes: ['image/jpeg', 'image/png'],
  imageThumbnailHeights: THUMBNAIL_SETTINGS,
};
